import {popupHandler } from './functions/popups.js';
import './functions/parallax.js';


jQuery( document ).ready( function( $ ) {    
    /**
     * Load popuphandler
     */
    popupHandler();


    /**
     * Handle scroll
     */

    $(window).on('scroll', function() {
        if ($(window).scrollTop() > 50) {
            $('header').addClass('scrolled');
        } else {
            $('header').removeClass('scrolled');
        }
    });

    
    /**
     * Handle menus
     */

    // Mobile: toggle submenu on click (scoped to mobile container)
    $('#mobile-menu-container .menu-item-has-children > a').on('click', function(e) {
        const $parent = $(this).parent();
        const isOpen = $parent.hasClass('open');

        // Close all open submenus first
        $('#mobile-menu-container .menu-item-has-children').each(function() {
            $(this).find('> ul').stop(true, true).slideUp(200);
            $(this).removeClass('open');
        });

        // Re-open if it wasn't already open
        if (!isOpen) {
            $(this).siblings('ul').stop(true, true).slideDown(200);
            $parent.addClass('open');
        }

        e.preventDefault();
    });

    // Desktop: hover-based submenu with close delay to allow diagonal mouse movement
    const mainMenuItems = document.querySelectorAll('#main-menu > li.menu-item-has-children');
    mainMenuItems.forEach(function(item) {
        let closeTimeout;

        function openSubmenu() {
            clearTimeout(closeTimeout);
            mainMenuItems.forEach(function(other) {
                if (other !== item) other.classList.remove('submenu-open');
            });
            item.classList.add('submenu-open');
        }

        function scheduleClose() {
            closeTimeout = setTimeout(function() {
                item.classList.remove('submenu-open');
            }, 200);
        }

        item.addEventListener('mouseenter', openSubmenu);
        item.addEventListener('mouseleave', scheduleClose);
    });

    // Close desktop submenus when clicking outside the menu
    document.addEventListener('click', function(e) {
        if (!e.target.closest('#main-menu')) {
            mainMenuItems.forEach(function(item) {
                item.classList.remove('submenu-open');
            });
        }
    });

    // Close mobile submenus when clicking outside an open submenu
    document.addEventListener('click', function(e) {
        if (!e.target.closest('#mobile-menu-container .menu-item-has-children')) {
            $('#mobile-menu-container .menu-item-has-children').each(function() {
                $(this).find('> ul').stop(true, true).slideUp(200);
                $(this).removeClass('open');
            });
        }
    });

    const hamburger = document.getElementById('mobile-hamburger-button');
    if (hamburger) {            
        let $siteNavigation = $('#mobile-menu-container'); 
        $siteNavigation.registerAsD_Popup({
            show(){
                this.addClass('open');                
                $('body').addClass('mobile-menu-is-open');
            },
            hide(){
                this.removeClass('open');
                $('body').removeClass('mobile-menu-is-open');
            }
        });
                
        hamburger.addEventListener( 'click', function() {            
            if ($siteNavigation.hasClass('open')){            
                $siteNavigation.hideD_Popup();
            } else {
                $siteNavigation.showD_Popup();
            }            
        });
    }    

    /**
     * Handle login form toggle
     */
    const login_form = $('.tswp-loginout-block > .tswp-block-inner-container');
    if(typeof login_form !== 'undefined'){
        login_form.registerAsD_Popup();
        const login_buttons = $('.tswp-toggle-login-form');
        for(let login_button of login_buttons){
            login_button.addEventListener( 'click', function() {
                if (login_form.is(':visible')){
                    login_form.hideD_Popup();
                } else {
                    login_form.showD_Popup();
                }
            });			
        }        
    }

    /**
     * Handle video popups
     */
    const video_player = $('.card-video-popup');
    if(typeof video_player !== 'undefined'){
        video_player.registerAsD_Popup();
        const video_buttons = $('.card-image.video');
        for(let video_button of video_buttons){
            video_button.addEventListener( 'click', function() {
                if (login_form.hasClass('open')){
                // if (video_player.is(':visible')){
                    console.log('video close');

                    // Stop the YouTube video by clearing and reloading the iframe src
                    const iframe = video_player.find('iframe');
                    console.log(iframe);
                    
                    if (iframe.length) {
                        console.log('stop video');
                        const src = iframe.attr('src');
                        iframe.attr('src', '');
                        iframe.attr('src', src);
                    }
                    video_player.hideD_Popup();
                } else {
                    video_player.showD_Popup();
                }
            });			
        }        
    }


});




